


































import { defineComponent, PropType } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { PostFileData } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import BaseSpinner from "@/components/BaseSpinner";
import PostFilePreview from "@/components/PostCreate/components/PostFilePreview";

export default defineComponent({
  name: "MainVideo",
  components: {
    BaseButton,
    BaseIconButton,
    BaseInputFileWithPreview,
    BaseSpinner,
    PostFilePreview,
  },
  props: {
    files: { type: Array as PropType<PostFileData[]>, required: true },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorText: { type: String, default: () => $t("File upload failed. Please try again") },
  },
});
